// extracted by mini-css-extract-plugin
export var barHolder = "style-module--bar-holder--LKUhT";